export default __webpack_public_path__ + "74368b110c6acb10fe8770f5541a3df5.png";